import React, { useContext } from 'react';

import { MobxZodField } from '@monoid-dev/mobx-zod-form';
import { getForm } from '@monoid-dev/mobx-zod-form-react';
import { makeMuiStyles, useCommonStyles } from '@styles';
import clsx from 'clsx';
import { ZodTypeAny } from 'zod';

const useStyles = makeMuiStyles((theme, common) => ({
  indexedFormContainer: {
    ...common.middleText,
    ...common.textGray700,
    display: 'grid',
    gridTemplateColumns: 'auto auto 1fr',
    rowGap: 10,
    columnGap: 18,
    '&.md': {
      columnGap: 9,
    },
    '& > label': {
      paddingTop: 6,
    },
    '&  > *[role="data"]': {
      paddingTop: 6,
    },
  },
}));

export interface IndexedFormContext {
  size: 'md' | 'lg';
}

const IndexedFormContext = React.createContext<IndexedFormContext>({} as any);

export type IndexedFormContainerProps = Partial<IndexedFormContext>;

export const IndexedFormContainer: React.FC<React.PropsWithChildren<IndexedFormContainerProps>> = ({
  children,
  size = 'lg',
}) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <IndexedFormContext.Provider
      value={{
        size,
      }}
    >
      <div className={clsx(size, classes.indexedFormContainer)}>{children}</div>
    </IndexedFormContext.Provider>
  );
};

export const IndexedLabel: React.FC<{
  index?: number;
  label?: string;
  field?: MobxZodField<ZodTypeAny>;
  required?: boolean;
}> = ({ index, label, field, required = false }) => {
  const classes = useCommonStyles();

  const { size } = useContext(IndexedFormContext);

  const form = field && getForm(field);

  const htmlFor = field && form?.bindLabel(field)?.htmlFor;

  return (
    <>
      <label>{index}</label>
      <label style={{ minWidth: size === 'lg' ? 188 : 100 }} htmlFor={htmlFor}>
        {label ?? field?.type.getFormMeta()?.label}
        {required && <span className={classes.textError}> *</span>}
      </label>
    </>
  );
};
